<div class="table-wrapper">
  <header class="table-header">
    <div fxLayout="row" fxLayoutAlign="center center" class="mb-3">
      <span class="mat-title text-uppercase mb-0">{{
        "lspEdiErrorReport.reportTitle" | translate
      }}</span>
      <mat-icon
        aria-hidden="false"
        aria-label="about-report"
        class="md-18 ml-2 medium-emphasis"
        [matTooltip]="'lspEdiErrorReport.aboutTooltip' | translate"
      >
        info
      </mat-icon>
      <app-reports-menu class="ml-1"></app-reports-menu>
    </div>

    <div fxFlex fxLayout fxLayoutAlign="flex-end">
      <form [formGroup]="form">
        <mat-form-field appearance="outline">
          <mat-label>{{
            "lspEdiErrorReport.chooseDateRange" | translate
          }}</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input
              matStartDate
              formControlName="startDate"
              placeholder="Start date"
            />
            <input
              matEndDate
              formControlName="endDate"
              placeholder="End date"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <button mat-icon-button type="button" (click)="openDialog()">
          <mat-icon
            aria-hidden="false"
            aria-label="help-button"
            class="medium-emphasis"
            [matTooltip]="'lspEdiErrorReport.helpTooltip' | translate"
          >
            help_outline
          </mat-icon>
        </button>

        <button mat-stroked-button aria-label="search-button" (click)="searchLspEdiErrorReport()" class="ml-2">
          {{ "lspEdiErrorReport.search" | translate }}
        </button>
        <button
          type="button"
          mat-flat-button
          class="ml-2"
          color="primary"
          (click)="exportAsExcel()"
          [disabled]="!isExporttoExcel"
          [matTooltip]="'lspEdiErrorReport.exportTooltip' | translate"
        >
          <mat-icon>file_download</mat-icon>
          {{ "lspEdiErrorReport.export" | translate }}
        </button>
      </form>
    </div>
  </header>

  <mat-progress-bar
    *ngIf="isFetching"
    mode="indeterminate"
    value="40"
  ></mat-progress-bar>

  <section class="banner-wrapper">
    <div
      role="banner"
      class="mat-banner py-3 mat-elevation-z1"
      *ngIf="isRawFileFound == false"
    >
      <div
        class="mat-banner-content d-flex align-items-center text-high-emphasis"
      >
        <mat-icon class="material-icons-outlined medium-emphasis mr-2"
          >error_outline</mat-icon
        >
        {{ "lspEdiErrorReport.noEDI" | translate }}
      </div>
    </div>
    <div
      role="banner"
      class="mat-banner py-3 mat-elevation-z1"
      *ngIf="isAuthenticated == false"
    >
      <div
        class="mat-banner-content d-flex align-items-center text-high-emphasis"
      >
        <mat-icon class="material-icons-outlined medium-emphasis mr-2"
          >dangerous</mat-icon
        >
        {{ "lspEdiErrorReport.unautheticatedUser" | translate }}
      </div>
    </div>
    <div
      role="banner"
      class="mat-banner py-3 mat-elevation-z1"
      *ngIf="isDataFound == false"
    >
      <div
        class="mat-banner-content d-flex align-items-center text-high-emphasis"
      >
        <mat-icon class="material-icons-outlined medium-emphasis mr-2"
          >dangerous</mat-icon
        >
        {{ "lspEdiErrorReport.noDataFound" | translate }}
      </div>
    </div>
    <div
      role="banner"
      class="mat-banner py-3 mat-elevation-z1"
      *ngIf="isDataSelected == false"
    >
      <div
        class="mat-banner-content d-flex align-items-center text-high-emphasis"
      >
        <mat-icon class="material-icons-outlined medium-emphasis mr-2"
          >report_problem</mat-icon
        >
        {{ "lspEdiErrorReport.noDataSelected" | translate }}
      </div>
    </div>
  </section>

  <section class="container-fluid py-3">
    <div
      id="container"
      [ngClass]="[isScrolling ? 'content-card' : 'content-card-hidden']"
      (scroll)="onScroll($event)"
      class="table-content"
    >
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        #lspEdiErrorReportTbSort="matSort"
      >
        <!-- LSP -->
        <ng-container matColumnDef="lsp">
          <th mat-header-cell *matHeaderCellDef>
            LSP
            <span class="resize-handle" (mousedown)="onResizeColumn($event, 1)">
            </span>
            <span class="sort" mat-sort-header></span>
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.lsp }}
          </td>
        </ng-container>

        <!-- Housebill -->
        <ng-container matColumnDef="housebill">
          <th mat-header-cell *matHeaderCellDef>
            House Bill
            <span class="resize-handle" (mousedown)="onResizeColumn($event, 2)">
            </span>
            <span class="sort" mat-sort-header></span>
          </th>
          <td mat-cell *matCellDef="let row">
            <button
              mat-flat-button
              class="p-0 housebill"
              [disableRipple]="true"
              (click)="showEntityStatus(row)"
            >
              <div 
                [ngClass]="{'text-primary': row.housebill != 'Unknown'}"
              >
                {{ row.housebill }}
              </div>
            </button>
          </td>
        </ng-container>

        <!-- Container Number -->
        <ng-container matColumnDef="containerNumber">
          <th mat-header-cell *matHeaderCellDef>
            Container No
            <span class="resize-handle" (mousedown)="onResizeColumn($event, 3)">
            </span>
            <span class="sort" mat-sort-header></span>
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.containerNumber }}
          </td>
        </ng-container>

        <!-- Endpoint -->
        <ng-container matColumnDef="endpoint">
          <th mat-header-cell *matHeaderCellDef>
            End Point
            <span class="resize-handle" (mousedown)="onResizeColumn($event, 4)">
            </span>
            <span class="sort" mat-sort-header></span>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="text-ellipsis-2-lines" style="max-width: 150px">
              {{ row.endpoint }}
            </div>
          </td>
        </ng-container>

        <!-- Json Object -->
        <ng-container matColumnDef="jsonObject">
          <th mat-header-cell *matHeaderCellDef>
            Json Object
            <span class="resize-handle" (mousedown)="onResizeColumn($event, 5)">
            </span>
            <span class="sort"></span>
          </th>
          <td mat-cell *matCellDef="let row">
            <div *ngIf="row.isPayload">
              <button
                *ngIf="this.responseLength"
                mat-icon-button
                [matTooltip]="'lspEdiErrorReport.viewPayloadTooltip' | translate"
                (click)="openJsonDialog(row.tableID)"
              >
                <mat-icon class="medium-emphasis">pageview</mat-icon>
              </button>

              <button
                *ngIf="this.responseLength"
                mat-icon-button
                [matTooltip]="'lspEdiErrorReport.downloadPayloadTooltip' | translate"
                (click)="onCopyJsonToClipboard(row.tableID)"
              >
                <mat-icon class="md-18 medium-emphasis">file_download</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Mapped To Object -->
        <ng-container matColumnDef="mappedToObject">
          <th mat-header-cell *matHeaderCellDef>
            Mapped To Object
            <span class="resize-handle" (mousedown)="onResizeColumn($event, 6)">
            </span>
            <span class="sort" mat-sort-header></span>
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.mappedToObject }}
          </td>
        </ng-container>

        <!-- File Received Time -->
        <ng-container matColumnDef="fileReceivedTime">
          <th mat-header-cell *matHeaderCellDef>
            File Received Time
            <span class="resize-handle" (mousedown)="onResizeColumn($event, 7)">
            </span>
            <span class="sort" mat-sort-header></span>
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.fileReceivedTime | date : "yyyy-MM-dd HH:mm:ss" }}
          </td>
        </ng-container>

        <!-- Original File Ref -->
        <ng-container matColumnDef="originalFileReference">
          <th mat-header-cell *matHeaderCellDef>
            Original File Reference
            <span class="resize-handle" (mousedown)="onResizeColumn($event, 8)">
            </span>
            <span class="sort" mat-sort-header></span>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="text-ellipsis">
              {{ row.originalFileReference }}
            </div>
            <button
              *ngIf="this.responseLength"
              mat-icon-button
              [matTooltip]="'lspEdiErrorReport.viewFileTooltip' | translate"
              (click)="openFileRefDialog(row.originalFileReference)"
            >
              <mat-icon class="medium-emphasis">pageview</mat-icon>
            </button>
            <button
              *ngIf="this.responseLength"
              mat-icon-button
              [matTooltip]="'lspEdiErrorReport.downloadFileTooltip' | translate"
              (click)="onDownloadEDI(row.originalFileReference)"
            >
              <mat-icon class="md-18 medium-emphasis">file_download</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Error Message -->
        <ng-container matColumnDef="errorMessage">
          <th mat-header-cell *matHeaderCellDef>
            Error Message
            <span
              class="resize-handle"
              (mousedown)="onResizeColumn($event, 9)"
            ></span>
            <span class="sort" mat-sort-header></span>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="text-ellipsis-2-lines">
              {{ row.errorMessage }}
            </div>
          </td>
        </ng-container>

        <!-- Total Count -->
        <ng-container matColumnDef="totalCount">
          <td
            mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
          >
            <span class="text-medium">
              {{ "lspEdiErrorReport.totalCount" | translate }}
              {{ this.responseLength }}</span
            >
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="['totalCount']; sticky: true"></tr>
      </table>
    </div>
  </section>
</div>
